module.exports = "/_next/static/videos/BEACH-752e8645353376a2ffef46fcbb606370.mp4";